import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface ContainerContentProps {
  children: ReactNode;
  background?: string;
  className?: string;
  style?: React.CSSProperties;
}

const Outer = styled.div<{ background: string }>`
  width: 100%;
  background: ${({ background }) => background};
`;

const Inner = styled.div`
  max-width: 840px;
  padding: 0px 16px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;

  .max-width-1200 & {
    max-width: 1200px;
  }
`;

const ContainerContent: React.FC<ContainerContentProps> = ({
  children,
  background = '#FFF',
  className,
  style,
}) => {
  return (
    <Outer background={background} className={className} style={style}>
      <Inner>{children}</Inner>
    </Outer>
  );
};

export default ContainerContent; 